import { makeStateKey } from "@angular/core";
import { HandledHttpResponse } from "@uzenith360/http-utils";
import Portfolio from "./types/porfolio.interface";

export default makeStateKey<HandledHttpResponse<Portfolio>>('portfolio-data');